import type { MouseEvent } from 'react';
import { mailtoHref, telHref } from '../lib/contactLinks';

/**
 * Real contact information that can be acted on: an email address opens the user's mail app (mailto:), a phone
 * number opens the dialer / calling app (tel:). The text is shown exactly as given — same formatting, same colour —
 * with only a pointer and a subtle underline on hover. Anything that is not a plausible address/number is rendered
 * as plain text, so this is safe to use wherever a value *might* be present.
 *
 * Clicking never triggers the surrounding row/card's own click handler (rows open drawers), and the text stays
 * selectable and copyable.
 */
const stop = (e: MouseEvent) => e.stopPropagation();

export function EmailLink({ email, className }: { email?: string | null; className?: string }) {
  const value = (email ?? '').trim();
  if (!value) return null;
  const href = mailtoHref(value);
  if (!href) return <>{email}</>;
  return (
    <a className={`contact-link${className ? ` ${className}` : ''}`} href={href} onClick={stop}>
      {email}
    </a>
  );
}

export function PhoneLink({ phone, className }: { phone?: string | null; className?: string }) {
  const value = (phone ?? '').trim();
  if (!value) return null;
  const href = telHref(value);
  if (!href) return <>{phone}</>;
  return (
    <a className={`contact-link${className ? ` ${className}` : ''}`} href={href} onClick={stop}>
      {phone}
    </a>
  );
}
